import _ from 'underscore';
import { dateFormats } from './constants';
import moment from 'moment';

const TODAY = moment();
const toMoment = (date) => moment(date, dateFormats.ISO_8601);

function getCurrentSession(sessions) {
  if (!_.isArray(sessions) || sessions.length === 0) {
    return null;
  }

  // sort by start and then end date
  const sortedSessions = _.sortBy(sessions, session => `${session.start}-${session.end}`);

  // pick the last one that is running today (if any are running today)
  const runningToday = _.filter(sessions, (session) => {
    const { start, end } = session;
    return !toMoment(start).isAfter(TODAY) && !toMoment(end).isBefore(TODAY);
  });

  if (runningToday.length > 0) {
    return _.last(runningToday);
  }

  // if none are current, then pick the first one that starts in the future
  const inFuture = _.filter(sessions, (session) => {
    return toMoment(session.start).isAfter(TODAY);
  });

  if (inFuture.length > 0) {
    return _.first(inFuture);
  }

  // just return the one that ends the latest
  return _.last(sortedSessions);
}


function isNotOver(session) {
  if (session) {
    const { end } = session;
    return moment(end, dateFormats.ISO_8601).isAfter(TODAY);
  } else {
    return false;
  }
}


function getUpcomingSessions(sessions, count = 3) {
  if (sessions) {
    return _.first(_.filter(sessions, isNotOver), count);
  } else {
    return [];
  }
}

export {
  getCurrentSession,
  getUpcomingSessions,
  isNotOver
};



// WEBPACK FOOTER //
// ./src/js/util/SessionUtils.js